const TurkmenistanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112601)">
      <path
        d="M20 0C18.5067 0 17.0521 0.165078 15.6522 0.475391L14.7827 19.9999L15.6522 39.5245C17.0522 39.8348 18.5068 40 20 40C31.0457 40 40 31.0456 40 19.9999C39.9999 8.9543 31.0457 0 20 0V0Z"
        fill="#496E2D"
      />
      <path
        d="M5.21734 6.52832C1.97641 10.0827 0 14.81 0 19.9993C0 25.1885 1.97648 29.9158 5.21742 33.4703L6.08695 19.9993L5.21734 6.52832Z"
        fill="#496E2D"
      />
      <path
        d="M29.2516 15.0862C30.2356 12.3435 29.1302 9.36063 26.7577 7.875C27.1845 7.93055 27.6116 8.03102 28.0332 8.18219C31.1975 9.3175 32.8423 12.8028 31.707 15.967C30.5717 19.1315 27.0864 20.7762 23.9221 19.6409C23.5005 19.4896 23.1068 19.2955 22.7422 19.0671C25.518 19.4286 28.2677 17.8288 29.2516 15.0862Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.7945 7.12402L22.9394 8.22887L21.6247 7.75707L22.4111 8.9116L21.5562 10.0163L22.8972 9.6252L23.6837 10.7796L23.7259 9.38332L25.067 8.99215L23.7522 8.52051L23.7945 7.12402Z"
        fill="#F0F0F0"
      />
      <path
        d="M26.1032 10.7227L25.2481 11.8274L23.9333 11.3556L24.7197 12.5102L23.8647 13.6148L25.2058 13.2236L25.9923 14.3782L26.0347 12.9819L27.3757 12.5906L26.0608 12.1189L26.1032 10.7227Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.7242 8.43359L18.8691 9.53828L17.5544 9.06664L18.3408 10.2211L17.4858 11.3259L18.8268 10.9347L19.6133 12.0891L19.6557 10.6929L20.9967 10.3017L19.6819 9.82992L19.7242 8.43359Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.63 12.5566L18.775 13.6614L17.4602 13.1897L18.2468 14.3442L17.3916 15.4489L18.7328 15.0578L19.5193 16.2122L19.5615 14.8159L20.9026 14.4248L19.5877 13.953L19.63 12.5566Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.5544 13.9648L22.6993 15.0695L21.3845 14.5978L22.1711 15.7523L21.3159 16.857L22.6571 16.4659L23.4436 17.6204L23.4858 16.224L24.8269 15.8329L23.512 15.3612L23.5544 13.9648Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.21729 6.52918V33.4711C7.94229 36.4597 11.5618 38.6179 15.6521 39.5246V0.475586C11.5617 1.3823 7.94236 3.54051 5.21729 6.52918Z"
        fill="#D80027"
      />
      <path
        d="M9.1991 10.53L7.45215 9.22863V7.38824L9.1991 6.08691H11.6698L13.4168 7.38824V9.22863L11.6698 10.53H9.1991Z"
        fill="#F0F0F0"
      />
      <path d="M10.4345 6.08691H9.1991L7.45215 7.38824V8.28801H10.4345V6.08691Z" fill="#FF9811" />
      <path d="M10.4341 10.5303H11.6694L13.4163 9.22887V8.29004H10.4341V10.5303Z" fill="#FF9811" />
      <path
        d="M9.1991 33.9119L7.45215 32.6105V30.7702L9.1991 29.4688H11.6698L13.4168 30.7702V32.6105L11.6698 33.9119H9.1991Z"
        fill="#F0F0F0"
      />
      <path d="M10.4345 29.4688H9.1991L7.45215 30.7702V31.6699H10.4345V29.4688Z" fill="#FF9811" />
      <path d="M10.4341 33.913H11.6694L13.4163 32.6116V31.6729H10.4341V33.913Z" fill="#FF9811" />
      <path
        d="M9.20008 22.2214L7.45312 20.92V19.0797L9.20008 17.7783H11.6708L13.4177 19.0797V20.92L11.6708 22.2214H9.20008Z"
        fill="#496E2D"
      />
      <path
        d="M13.4785 25.0852H12.7175V24.3244H11.3804L10.435 23.3789L9.48957 24.3244H8.15246V25.0852H7.3916V26.607H8.15246V27.3678H9.48949L10.435 28.3134L11.3804 27.3678H12.7175V26.607H13.4785V25.0852Z"
        fill="#496E2D"
      />
      <path
        d="M13.4785 13.3929H12.7175V12.632H11.3804L10.435 11.6865L9.48957 12.632H8.15246V13.3929H7.3916V14.9146H8.15246V15.6755H9.48949L10.435 16.6211L11.3804 15.6755H12.7175V14.9146H13.4785V13.3929Z"
        fill="#496E2D"
      />
      <path d="M9.56494 19.1299H11.3041V20.869H9.56494V19.1299Z" fill="#D80027" />
      <path
        d="M10.4345 15.0242C10.9147 15.0242 11.304 14.6349 11.304 14.1547C11.304 13.6745 10.9147 13.2852 10.4345 13.2852C9.95424 13.2852 9.56494 13.6745 9.56494 14.1547C9.56494 14.6349 9.95424 15.0242 10.4345 15.0242Z"
        fill="#D80027"
      />
      <path
        d="M10.4345 26.7156C10.9147 26.7156 11.304 26.3263 11.304 25.8461C11.304 25.3659 10.9147 24.9766 10.4345 24.9766C9.95424 24.9766 9.56494 25.3659 9.56494 25.8461C9.56494 26.3263 9.95424 26.7156 10.4345 26.7156Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112601">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TurkmenistanSvg;
